export default __webpack_public_path__ + "static/media/1275.18f83975.png";